export const KEY_VAL_SEPARATOR = "--*-*--";
export const SHIPPING_LOCATIONS_KEY = "shipping_locations";
